var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$country === 'ru' ? 'version-ru' : 'version'},[_vm._v(" "+_vm._s(_vm.$country === 'ru' ? 'BETBOOM 3.0.7' : 'BetBoom 3.0.7')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }